<aside class="chatbot-sidebar" aria-label="Chatbot sidebar">
  <talk-to-your-data-brand-group></talk-to-your-data-brand-group>
  <talk-to-your-data-new-chat-button (newChatClicked)="onNewChat()"></talk-to-your-data-new-chat-button>
  <!-- <talk-to-your-data-quick-question-list
    [quickQuestions]="quickQuestions || []"
    (questionSelected)="onQuickQuestionSelected($event)"
  ></talk-to-your-data-quick-question-list> -->
  <!-- <hr class="message-item__divider" /> -->
  <talk-to-your-data-saved-conversations
    [savedConversations]="savedConversations || []"
    [selectedConversationId]="selectedConversationId"
    (conversationSelected)="onConversationSelected($event)"
    (conversationRemoved)="onConversationUnsaved($event)"
    (conversationRenamed)="onConversationRenamed($event)"
    (conversationDeleted)="onConversationDeleted($event)"
  ></talk-to-your-data-saved-conversations>
  <hr class="chatbot-sidebar__divider" />
  <talk-to-your-data-conversation-history
    [history]="conversationHistory || []"
    [selectedConversationId]="selectedConversationId"
    (conversationSelected)="onConversationSelected($event)"
    (conversationSaved)="onConversationSaved($event)"
    (conversationRenamed)="onConversationRenamed($event)"
    (conversationDeleted)="onConversationDeleted($event)"
  ></talk-to-your-data-conversation-history>
  <talk-to-your-data-user-profile
    class="chatbot-sidebar__profile"
    [userProfile]="userProfile"
  ></talk-to-your-data-user-profile>
</aside>
